
import { parseISO, format } from 'date-fns'

export default {
    props: {
        guest: {
            type: Object,
            default: () => {
                return {}
            },
        },

        event: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            eventCount: null,
        }
    },

    computed: {
        formatDate() {
            if (this.event.date) {
                const datePart = format(parseISO(this.event.date.replace(/Z/,'')), 'MMMM d, yyyy')
                const timePart = format(parseISO(this.event.date.replace(/Z/,'')), 'h a')
                return `${datePart}${datePart && timePart ? ' at ' + timePart : timePart || ''}`
            }
            return ''
        },

        isNoLimit() {
            return !this.event.plus_one_count || parseInt(this.event.plus_one_count) === -1
        },

        eventPlusOnes() {
            return this.guest.children?.length
                ? this.guest.children.filter((gst) => gst.wedding_events.findIndex((ev) => ev.id === this.event.id && [1, 2, 3].includes(ev.status)) !== -1)
                : []
        },

        calculatedPlusOneCount() {
            let plusOneCount = parseInt(this.event.plus_one_count - 1 || 0)
            const childrenCount = this.eventPlusOnes.length || 0

            if (this.isNoLimit) {
                if (this.eventCount) plusOneCount = this.eventCount
                else return 0
            }

            return plusOneCount - childrenCount
        },

        showPlusOnes() {
            return (
                this.event.status === 3 &&
                (this.isNoLimit ? !this.eventCount || this.eventPlusOnes.length || this.calculatedPlusOneCount : this.event.plus_one_count - 1)
            )
        },

        showQuestions() {
            return this.event.questions && this.event.questions.length && this.event.status === 3
        },
    },

    methods: {
        setWeddingEvent(data) {
            if (data.guest.id === this.guest.id) {
                this.$set(
                    this.guest.wedding_events,
                    this.guest.wedding_events.findIndex((el) => el.id === data.event.id),
                    data.event
                )
            } else if (this.guest.children?.length) {
                const idx = this.guest.children.findIndex((el) => el.id === data.guest.id)
                if (idx !== -1) {
                    this.$set(
                        this.guest.children[idx].wedding_events,
                        this.guest.children[idx].wedding_events.findIndex((el) => el.id === data.event.id),
                        data.event
                    )

                    if (this.isNoLimit && !data.event.status && this.eventCount) this.eventCount--
                }
            }

            this.$emit('input', this.guest.wedding_events)
        },

        setNewGuest(guest) {
            if (this.guest?.children?.length) {
                const idx = this.guest.children.findIndex((el) => el.id === guest.id)

                if (idx === -1) this.guest.children.push(guest)
                else this.$set(this.guest.children, idx, guest)
            } else this.guest.children = [guest]
        },

        addPlusOne() {
            this.eventCount = this.eventCount ? this.eventCount + 1 : this.eventPlusOnes.length + 1
        },
    },
}
